export default "__VITE_ASSET__DNh6ZVB5__"